import React from "react";
import Reveal from "../ui/Reveal";
import SectionHeading from "../ui/SectionHeading";
import { STATS, FACTS, SITE } from "../../data/portfolio";
import MyPic from "../../images/WhatsApp_Image_2026-03-24_at_14.42.08-removebg-preview.png";

function About() {
  return (
    <section id="about" className="section">
      <div className="container-page flex flex-col gap-14">
        <SectionHeading
          kicker="About"
          title="A developer who ships across the whole stack"
          subtitle="From database schema and API design to responsive interfaces — with detours into embedded systems and machine learning."
        />

        <div className="grid grid-cols-1 gap-10 lg:grid-cols-[0.85fr_minmax(0,1.15fr)] lg:items-center">
          <Reveal className="relative mx-auto w-full max-w-sm">
            <div className="absolute -inset-3 -z-10 rounded-3xl bg-gradient-to-br from-accent/30 to-transparent blur-2xl" />
            <div className="card-surface overflow-hidden p-2 shadow-card">
              <img
                src={MyPic}
                alt={SITE.name}
                className="aspect-[4/5] w-full rounded-xl object-cover"
                loading="lazy"
              />
            </div>
          </Reveal>

          <div className="flex min-w-0 flex-col gap-6">
            <Reveal as="p" className="text-base leading-relaxed text-ink-muted sm:text-lg">
              I&apos;m a <span className="text-ink">software engineer</span> with a passion for
              embedded and intelligent systems, driven by a love for building things that
              work end-to-end. Most of my day-to-day is spent in the{" "}
              <span className="text-accent-soft">MERN stack</span>, designing APIs, modelling
              data and crafting front-ends that feel fast and considered.
            </Reveal>
            <Reveal as="p" delay={80} className="text-base leading-relaxed text-ink-muted sm:text-lg">
              Outside the browser I work with{" "}
              <span className="text-accent-soft">C++ on microcontrollers</span> and{" "}
              <span className="text-accent-soft">Python for ML</span> — the same
              problem-solving instinct, different constraints. I&apos;m a strong believer in a
              purpose-driven life and stay endlessly curious about where these fields
              converge.
            </Reveal>

            <Reveal className="grid grid-cols-1 gap-3 sm:grid-cols-2">
              {FACTS.map((f) => (
                <div key={f.k} className="card-surface p-4">
                  <div className="font-mono text-[0.7rem] uppercase tracking-widest text-accent-soft">
                    {f.k}
                  </div>
                  <div className="mt-1 text-sm text-ink-muted">{f.v}</div>
                </div>
              ))}
            </Reveal>
          </div>
        </div>

        <Reveal className="grid grid-cols-2 gap-4 sm:grid-cols-4">
          {STATS.map((s) => (
            <div key={s.label} className="card-surface p-5 text-center">
              <div className="font-display text-3xl font-bold text-gradient sm:text-4xl">
                {s.value}
              </div>
              <div className="mt-1 text-xs text-ink-faint sm:text-sm">{s.label}</div>
            </div>
          ))}
        </Reveal>
      </div>
    </section>
  );
}

export default About;
